var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBankTransfer = function SvgBankTransfer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FDEDE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2918 10.7119C15.7098 10.3919 16.2908 10.3919 16.7088 10.7119L21.6708 14.5049C22.3028 14.9879 21.9638 15.9959 21.1698 15.9999H10.8298C10.0368 15.9959 9.69684 14.9879 10.3298 14.5049L15.2918 10.7119ZM15.9998 14.2499C16.1988 14.2499 16.3895 14.1709 16.5302 14.0303C16.6708 13.8896 16.7498 13.6988 16.7498 13.4999C16.7498 13.301 16.6708 13.1102 16.5302 12.9696C16.3895 12.8289 16.1988 12.7499 15.9998 12.7499C15.8009 12.7499 15.6102 12.8289 15.4695 12.9696C15.3289 13.1102 15.2498 13.301 15.2498 13.4999C15.2498 13.6988 15.3289 13.8896 15.4695 14.0303C15.6102 14.1709 15.8009 14.2499 15.9998 14.2499Z",
    fill: "#EE6F44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17V20H13V17H11.5Z",
    fill: "#EE6F44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17V20H15.5V17H14Z",
    fill: "#EE6F44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17V20H18V17H16.5Z",
    fill: "#EE6F44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17V20H20.5V17H19Z",
    fill: "#EE6F44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.25C10 21.56 10.56 21 11.25 21H20.75C21.44 21 22 21.56 22 22.25V22.5C22 22.6326 21.9473 22.7598 21.8536 22.8536C21.7598 22.9473 21.6326 23 21.5 23H10.5C10.3674 23 10.2402 22.9473 10.1464 22.8536C10.0527 22.7598 10 22.6326 10 22.5V22.25Z",
    fill: "#EE6F44"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBankTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank_transfer.d4044a4f.svg";
export { ForwardRef as ReactComponent };